import { useCallback } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { SendCustomMailSettingMutationForReservationCancel } from "./mutation";

export const useSendCustomMailSettingForReservationCancel = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(SendCustomMailSettingMutationForReservationCancel);

	const sendTestMailAtReservationCancel = useCallback(
		async (input: CustomMailSettingTestMailInput) => {
			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					title: "予約をキャンセルした際のテストメールを送信しました",
				});
			}
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return { sendTestMailAtReservationCancel };
};
